import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS = {
	// "0":"ButtonSubmit0",
	signature: 'Text22',
	date: 'Text21',
	faxNumber: 'Text20',
	lawFirmAddress: 'Text19',
	telephoneNumber: 'Text18',
	lawFirmName: 'Text17',
	trustNumber: 'Text16',
	fundsDateRequired: 'Text15',
	transitNumber: 'Text14',
	requisitionedAmount: 'Text13',
	bankName: 'Text12',
	interestAdjustmentDate: 'Text11',
	mortgageAmount: 'Text10',
	annualTaxAmount: 'Text9',
	rollNumber: 'Text8',
	municipalTaxOffice: 'Text7',
	legalDescription: 'Text6',
	propertyAddress: 'Text5',
	mortgagor: 'Text4',
	cibcReferenceNumber: 'Text3',
	re: 'Text2',
	// "22":"CC001"
};

export interface CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS {
	re: string;
	cibcReferenceNumber: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;
	municipalTaxOffice: string;
	rollNumber: string;
	annualTaxAmount: string;

	mortgageAmount: string;
	interestAdjustmentDate: string;

	bankName: string;
	requisitionedAmount: string;
	transitNumber: string;
	fundsDateRequired: string;
	trustNumber: string;

	lawFirmName: string;
	telephoneNumber: string;
	lawFirmAddress: string;
	faxNumber: string;

	date: string;
	signature: string;
}
